import React from 'react'

function ShiftingProcess() {
  return (
    <div>
        
   
          <div className='shiftingprocess'>
            <br/>
      <div className="album py-2">
        <div className="container">
          <center>
          <h3 style={{ color: "darkBlue" }}><b>Shifting Process</b></h3>
          </center>
        </div>
      </div>

      <div className="album py-1">
        <div className="container">
          <p className='justify'>Relocating offices, homes, warehouses, pets, or vehicles can be a complex and time-consuming process, especially without proper planning and execution. Attempting to manage it all alone often leads to unnecessary stress and complications. That’s why it’s wise to hire experienced professionals who can ensure a smooth, safe, and hassle-free relocation. At AT India Packers Movers, we simplify the shifting process with end-to-end solutions — from careful packing and secure transportation to unloading and even reassembly, if requested. All our services are tailored to fit your budget, ensuring a stress-free moving experience.</p>

          <div className="accordion" id="accordionExample">
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingOne">
                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                  <b>Pre-Move Survey </b>
                </button>
              </h2>
              <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                <div className="accordion-body">
                  <h6>Our relocation process begins with a detailed pre-move survey. Our expert team visits your location to assess the volume of goods, understand specific requirements, and provide an accurate quotation tailored to your needs.</h6>
 


                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingTwo">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                  <b>Professional Packing</b>
                </button>
              </h2>
              <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                <div className="accordion-body">

                  <h6>We use high-quality packing materials and techniques to ensure the safety of your belongings. Fragile and valuable items receive extra attention with customized packing for maximum protection during transit.</h6>

                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingThree">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                  <b>Safe Loading & Transportation</b>
                </button>
              </h2>
              <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                <div className="accordion-body">
                  <h6>Once packed, all items are carefully loaded into well-maintained transport vehicles. Our trained staff ensures secure handling, and GPS-enabled vehicles allow real-time tracking for your peace of mind.</h6>

                </div>
              </div>
            </div>


            <div className="accordion-item">
              <h2 className="accordion-header" id="headingFour">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                  <b>Timely Unloading & Unpacking</b>
                </button>
              </h2>
              <div id="collapseFour" className="accordion-collapse collapse" aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                <div className="accordion-body">

                <h6>Upon reaching the destination, our team unloads and, if requested, unpacks your belongings with care. We ensure everything is placed as per your instructions to help you settle in quickly.</h6>

                </div>
              </div>
            </div>


            <div className="accordion-item">
              <h2 className="accordion-header" id="headingFive">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                  <b>Post-Move Support </b>
                </button>
              </h2>
              <div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="headingFive" data-bs-parent="#accordionExample">
                <div className="accordion-body">
               <h6>We believe in complete customer satisfaction, so our job doesn’t end at delivery. We offer post-move assistance to handle any queries or concerns, making your relocation truly stress-free.</h6>

                </div>
              </div>
            </div>

           
          </div>
          </div>
        </div>
        <br/>
      </div>

     
    </div>
  )
}

export default ShiftingProcess